// import { authFetch } from '../../AuthFetch';
import {
    cleanGlobalMessage,
    forwardToShowGlobalAlert
} from '../../actions';

export const go = (dispatch, request, value, attr, callback) => {
    dispatch(callback(request, value, attr));
    dispatch(cleanGlobalMessage());
}

export const error = (dispatch, result) => {
    if (!result.pass) {
        dispatch(forwardToShowGlobalAlert(result.error));
    }
}

export const clean = (dispatch) => {
    dispatch(cleanGlobalMessage());
}

export const beforeGo = (dispatch, callback) => { }
export const afterGo = (dispatch, callback) => { }
export const run = (dispatch, callback) => { }    


// WEBPACK FOOTER //
// ./src/actions/utils/Go.js